import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import { withRouter, Link } from "react-router-dom";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Breadcrumb from "../../components/Breadcrumb";
import Loading from "../../components/loadingSpinner/Loading";
import AdminDateFilter from "../../components/admin/AdminDateFilter";
import AdminStatCard from "../../components/admin/AdminStatCard";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import moment from "moment";

@inject("adminStore")
@withRouter
@observer
class AdminBookings extends Component {
    breadcrumb = [
        { name: "Admin Dashboard", link: "/admin" },
        { name: "Bookings & Revenue" }
    ];
    
    state = {
        isLoading: true,
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month")
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { startDate, endDate } = this.state;
        this.setState({ isLoading: true });
        
        this.props.adminStore.getBookingsStats(
            startDate.format("YYYY-MM-DD"),
            endDate.format("YYYY-MM-DD")
        ).then(() => {
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
    };

    handleDateChange = (startDate, endDate) => {
        this.setState({ startDate, endDate }, this.loadData);
    };

    render() {
        const { isLoading } = this.state;
        const { bookingsStats } = this.props.adminStore;

        return (
            <Fragment>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={this.breadcrumb} />
                    <Fragment>
                        <Paper style={{ padding: 16, marginBottom: 16 }}>
                            <Grid container spacing={16} alignItems="center">
                                <Grid item>
                                    <Button
                                        component={Link}
                                        to="/admin"
                                        size="small"
                                        style={{ marginRight: 16 }}
                                    >
                                        <ArrowBackIcon style={{ marginRight: 4 }} />
                                        Back to Overview
                                    </Button>
                                </Grid>
                                <Grid item xs>
                                    <Typography variant="h5" style={{ color: "#262626", fontWeight: 600 }}>
                                        Bookings & Revenue
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <AdminDateFilter onDateChange={this.handleDateChange} />
                                </Grid>
                            </Grid>
                        </Paper>

                        <Loading showed={isLoading} />

                        <Typography variant="subtitle1" style={{ marginBottom: 8, fontWeight: 600, color: "#666" }}>
                            Gigs
                        </Typography>
                        <Grid container spacing={16} style={{ marginBottom: 24 }}>
                            <Grid item xs={12} sm={6} md={3}>
                                <AdminStatCard
                                    title="Total Gigs Booked"
                                    total={bookingsStats.totalGigs}
                                    newCount={bookingsStats.newGigs}
                                    color="#ff5722"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <AdminStatCard
                                    title="New Gigs"
                                    total={bookingsStats.newGigs}
                                    newCount={bookingsStats.newGigs}
                                    newLabel="in selected period"
                                    color="#4caf50"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <AdminStatCard
                                    title="Completed"
                                    total={bookingsStats.completedGigs}
                                    newCount={bookingsStats.completedGigs}
                                    newLabel="in selected period"
                                    color="#2196f3"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <AdminStatCard
                                    title="Historical"
                                    total={bookingsStats.historicalGigs}
                                    newCount={0}
                                    newLabel="before this period"
                                    color="#9c27b0"
                                />
                            </Grid>
                        </Grid>

                        <Typography variant="subtitle1" style={{ marginBottom: 8, fontWeight: 600, color: "#666" }}>
                            Revenue
                        </Typography>
                        <Grid container spacing={16}>
                            <Grid item xs={12} sm={6} md={3}>
                                <AdminStatCard
                                    title="Total Booking Value"
                                    total={bookingsStats.totalValue}
                                    newCount={bookingsStats.newValue}
                                    color="#673ab7"
                                    isCurrency
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <AdminStatCard
                                    title="New Value"
                                    total={bookingsStats.newValue}
                                    newCount={bookingsStats.newValue}
                                    newLabel="in selected period"
                                    color="#4caf50"
                                    isCurrency
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <AdminStatCard
                                    title="Completed Value"
                                    total={bookingsStats.completedValue}
                                    newCount={bookingsStats.completedValue}
                                    newLabel="in selected period"
                                    color="#2196f3"
                                    isCurrency
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <AdminStatCard
                                    title="Historical Value"
                                    total={bookingsStats.historicalValue}
                                    newCount={0}
                                    newLabel="before this period"
                                    color="#9c27b0"
                                    isCurrency
                                />
                            </Grid>
                        </Grid>
                    </Fragment>
                </MainContainer>
            </Fragment>
        );
    }
}

export default AdminBookings;
